/*
 * PrepareUp.ai coming-soon page — everything that needs a real value lives here.
 *
 * Leave a value as null until it's verified. The page never invents a link:
 * a missing URL hides that link (socials) or shows an honest "coming soon"
 * state (Topmate buttons).
 */
export const COMING_SOON = {
  // LOGIN LOCK. While false, every visitor — signed in or not — sees only this
  // coming-soon page: the login screen is never rendered and an existing
  // saved session does not open the app. Set to true when the app is ready
  // to open; the login is then reached at #signin.
  loginEnabled: false,

  // The launch date as 'YYYY-MM-DD'. When set, the page counts down from it;
  // when null it says "approximately 45 days".
  launchDate: null,
  approxDays: 45,

  // Official channels. null = not shown.
  youtubeUrl: null,
  instagramUrl: null,

  // The simulated AI interviewer shown in the AI Video Interviews preview (a file
  // in /public). Cropped from the approved landing-page mockup; swap for a
  // higher-resolution portrait when one is available. null = an empty video tile.
  interviewerImage: '/coming-soon/interviewer.jpg',

  guides: [
    {
      id: 'sachin',
      name: 'Sachin Nowal',
      title: 'Data Scientist Lead',
      expertise: ['Data Science', 'ML/AI', 'DSA & Coding', 'Interview Preparation', 'Career Guidance'],
      topmateUrl: 'https://topmate.io/sachin_nowal/',
      photo: null,        // TODO: e.g. '/coming-soon/sachin.jpg' in /public
    },
    {
      id: 'muskan',
      name: 'Muskan Sharma',
      title: 'Senior UX Researcher',
      expertise: ['UX Research', 'Product Thinking', 'Interview Preparation', 'Career Guidance'],
      topmateUrl: 'https://topmate.io/muskan_sharma56',
      photo: null,        // TODO: e.g. '/coming-soon/muskan.jpg' in /public
    },
  ],
};

/** Whole days until the configured launch date (never negative), or null when no date is set. */
export const daysToLaunch = (now = new Date()) => {
  const d = COMING_SOON.launchDate ? new Date(`${COMING_SOON.launchDate}T00:00:00`) : null;
  if (!d || Number.isNaN(d.getTime())) return null;
  return Math.max(0, Math.ceil((d.getTime() - now.getTime()) / 86400000));
};
